import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { HouseStatusSettingService } from "@root/router/setting/custom-config/house-status-setting.service";
import * as moment from "moment";
import { Moment } from "moment";
import { Subscription, merge, Subject, fromEvent } from "rxjs";
import _, { find, groupBy, head, keyBy, last, mapValues } from "lodash";
import { tap, takeUntil, distinctUntilChanged, take, skip, throttle, debounceTime } from "rxjs";
import { WritePermissionGurd } from "@root/util/decorator";
import { ModalService } from "@root/router/index/modal.service";
import {
  Child,
  DateRange,
  MultiHouseCalendarService,
  Parent,
  SelectedData,
} from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";
import { HttpClient } from "@angular/common/http";
import { differenceInDays, isSameDay, parse, subDays } from "date-fns";
import { CacheService } from "@delon/cache";
import { NzDrawerComponent, NzDrawerRef } from "ng-zorro-antd/drawer";
import { TranslateService } from "@root/shared/service/translate.service";
import { DateService } from "@root/shared/service/date.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { ContinueStayComponent } from "@root/router/component/house-order-detail/house-order-basic/continue-stay/continue-stay.component";
import { TaskDetailService } from "@root/router/component/task/task-detail/task-detail.service";

enum DrawerType {
  HostexSidebar,
  HourResvSidebar,
  ResvDetail,
  TaskDetail,
}

@Component({
  selector: "host-single-status-calendar-v2",
  templateUrl: "./single-status-calendar-v2.component.html",
  styleUrls: ["./single-status-calendar-v2.component.scss"],
})
export class SingleStatusCalendarV2Component implements OnInit, AfterViewInit, OnDestroy {
  private readonly CalendarApi = "/api/calendar/v3_listing_calendar";
  // @ViewChild("calendarContainer", { static: true }) calendarContainer: ElementRef;
  @ViewChild("scrollContainer") scrollContainerV2: ElementRef;
  @Input() id;
  listOfMonthOption: string[] = [];

  inviewedMonth: Set<string> = new Set();

  houseInfo;
  priceInfo;
  currentMonth = moment().format("YYYY-MM");
  reservationStyle;
  calendarMap = {};
  reservationMap = {};
  hourReservationMap = {};
  taskMap = {};
  channelColorMap = {};
  // selectStatus = {
  //   status: 'none',
  //   dates: null,
  // };

  selectedReservation = null;
  listOfSelectedDates: DateRange = {
    head: null,
    last: null,
  };

  selectStatus: "done" | "none" | "doing" = "none";

  /**
   * 一共有四种类型的侧边栏，为了方便管理，每打开一个，都必须关闭其他三个
   */
  hostexSiderbarDrawerRef: NzDrawerRef;
  hourResvSidebarDrawerRef: NzDrawerRef;
  resvDetailDrawerRef: NzDrawerRef;
  taskDrawerRef: NzDrawerRef;

  showLeadChannel: boolean = this.getLocalCachedValue("price") as boolean;
  showBookingRulesOfLC: boolean = this.getLocalCachedValue("rule") as boolean;

  initialized = false;

  private deprecatedCancelSelectCellEventFromOutsider = this.calendarSrv.selectRaw$.pipe(
    tap((value) => {
      console.log("selectRaw$: ", value);
      // this.selectStatus = value;
      // if (value.status !== 'none') {
      //   this.houseCalendarService.cancelSelectReservation();
      // }
      if (value.status !== "done") {
        this.drawerHelper.close("all");
        this.listOfSelectedDates = {
          head: null,
          last: null,
        };
        this.selectStatus = "none";
      }
      return;
      if (value.status === "done") {
        this.drawerHelper.open(DrawerType.HostexSidebar);

        // this.hostexSiderbarDrawerRef = this.modal.displayHostexSidebar();
        // this.offsetDrawerRef(370);
      } else {
        // this.offsetDrawerRef(0);
        this.drawerHelper.close("all");
        // this.hostexSiderbarDrawerRef?.close();
        // this.hourResvSidebarDrawerRef?.close();
      }

      console.log("hostex siderbar drawer ref: ", this.hostexSiderbarDrawerRef);
      // this.checkIfNeedOffset();
    }),
  );

  private hourReservationSidebar$ = this.calendarSrv.hourReservationRaw$.pipe(
    tap((value) => {
      console.log("create hour reservation: ", value);

      this.drawerHelper.open(DrawerType.HourResvSidebar);

      // this.hostexSiderbarDrawerRef?.close();
      // this.hourResvSidebarDrawerRef = this.modal.displayHourResvSidebar();
      // this.offsetDrawerRef(370);
      // this.checkIfNeedOffset();
    }),
  );
  private deprecatedCancelSelectResvFromOutsider = this.calendarSrv.selectReservationRaw$.pipe(
    tap((value) => {
      console.log("select reservation: ", value);
      this.selectedReservation = value;
      if (!value) {
        this.drawerHelper.close(DrawerType.ResvDetail);
      }

      return;
      if (value) {
        this.drawerHelper.open(DrawerType.ResvDetail);

        // this.houseCalendarService.cancelSelect();

        // this.offsetDrawerRef(370);
        // this.resvDetailDrawerRef = this.modal.displayResvDetailDrawer(value, this.resvDetailDrawerRef);
        console.log("resvDetailDrawerRef: ", this.resvDetailDrawerRef);
      } else {
        this.drawerHelper.close(DrawerType.ResvDetail);
        // this.offsetDrawerRef(0);
        // this.resvDetailDrawerRef?.close();
        console.log("resvDetailDrawerRef: ", this.resvDetailDrawerRef);
      }
      // this.checkIfNeedOffset();
    }),
  );

  private closeTaskDetailDrawer$ = this.taskDetailSrv.closeDrawer$.pipe(
    tap(() => {
      this.drawerHelper.close(DrawerType.TaskDetail);
    }),
  );

  private calendarRefresh$ = this.calendarSrv.calendarRefreshRaw$;

  private dateChangeRaw$ = new Subject<{
    type: "month" | "year";
    date: string;
  }>();
  private dateChange$ = this.dateChangeRaw$.pipe(
    distinctUntilChanged(),
    tap((value) => {
      this.currentMonth = value.date; // YYYY-MM || YYYY
    }),
  );

  private destroy$ = new Subject();

  private drawerHelper = {
    open: (type: DrawerType, ...rest) => {
      switch (type) {
        case DrawerType.HostexSidebar: {
          this.hourResvSidebarDrawerRef?.close();
          this.resvDetailDrawerRef?.close();
          this.taskDrawerRef?.close();

          this.hostexSiderbarDrawerRef = this.modal.displayHostexSidebar(rest?.[0]);
          // this.hostexSiderbarDrawerRef.afterClose.subscribe(() => {
          //   this.offsetDrawerRef(0);
          // });
          break;
        }
        case DrawerType.HourResvSidebar: {
          this.hostexSiderbarDrawerRef?.close();
          this.resvDetailDrawerRef?.close();
          this.taskDrawerRef?.close();

          this.hourResvSidebarDrawerRef = this.modal.displayHourResvSidebar(rest?.[0]);
          // this.hourResvSidebarDrawerRef.afterClose.subscribe(() => {
          //   this.offsetDrawerRef(0);
          // });
          break;
        }
        case DrawerType.ResvDetail: {
          this.hostexSiderbarDrawerRef?.close();
          this.hourResvSidebarDrawerRef?.close();
          this.taskDrawerRef?.close();

          this.resvDetailDrawerRef = this.modal.displayResvDetailDrawer(
            this.selectedReservation,
            this.resvDetailDrawerRef,
          );
          // this.resvDetailDrawerRef.afterClose.subscribe(() => {
          //   this.offsetDrawerRef(0);
          // });
          break;
        }
        case DrawerType.TaskDetail: {
          this.hostexSiderbarDrawerRef?.close();
          this.hourResvSidebarDrawerRef?.close();
          this.resvDetailDrawerRef?.close();
          console.log("rest: ", rest);
          this.taskDrawerRef = this.modal.displayTaskDetailDrawer(rest[0], rest[1], this.taskDrawerRef);
          // this.taskDrawerRef.afterClose.subscribe(() => {
          //   this.offsetDrawerRef(0);
          // });
          break;
        }
      }
      this.offsetDrawerRef(320);
    },
    close: (type: DrawerType | "all") => {
      switch (type) {
        case DrawerType.HostexSidebar:
          this.hostexSiderbarDrawerRef?.close();
          break;
        case DrawerType.HourResvSidebar:
          this.hourResvSidebarDrawerRef?.close();
          break;
        case DrawerType.ResvDetail:
          this.resvDetailDrawerRef?.close();
          break;
        case DrawerType.TaskDetail:
          this.taskDrawerRef?.close();
          break;
        case "all":
          this.hostexSiderbarDrawerRef?.close();
          this.hourResvSidebarDrawerRef?.close();
          this.resvDetailDrawerRef?.close();
          this.taskDrawerRef?.close();
          break;
      }
      this.offsetDrawerRef(0);
    },
  };

  constructor(
    private el: ElementRef,
    private modal: ModalService,
    private nzModal: NzModalService,
    private calendarService: HttpCalendarService,
    private commonConfigService: HouseStatusSettingService,
    private calendarSrv: MultiHouseCalendarService,
    private taskDetailSrv: TaskDetailService,
    private t: TranslateService,
    private dateSrv: DateService,
    private http: HttpClient,
    private cache: CacheService,
    private drawerRef: NzDrawerRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.deprecatedCancelSelectCellEventFromOutsider.pipe(takeUntil(this.destroy$)).subscribe(() => {});

    this.deprecatedCancelSelectResvFromOutsider.pipe(takeUntil(this.destroy$)).subscribe();
    this.hourReservationSidebar$.pipe(takeUntil(this.destroy$)).subscribe();
    this.closeTaskDetailDrawer$.pipe(takeUntil(this.dateChange$)).subscribe();

    this.calendarRefresh$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.fetchCalendarV2();
    });

    this.dateChange$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.fetchCalendarV2();
    });
  }

  ngAfterViewInit() {
    this.initMonthOptions();
    this.fetchHouseList();
    this.fetchCalendarV2();
    this.fetchCommonConfig();

    let id = setTimeout(() => {
      this.subscribeScrollEvent();
      this.scrollTo(this.currentMonth);

      clearTimeout(id);
      id = null;
    }, 200);
  }

  private offsetDrawerRef(value: number) {
    if (this.drawerRef) {
      this.drawerRef.nzOffsetX = value;
    }
  }

  private getLocalCachedValue(name: "price" | "rule"): boolean {
    return this.cache.getNone(`hostex.single_status_calendar.lead_channel_${name}`);
  }

  private setLocalCachedValue(name: "price" | "rule", value) {
    this.cache.set(`hostex.single_status_calendar.lead_channel_${name}`, value, { type: "s" });
  }

  private fetchHouseList() {
    const params = {
      page: 1,
      page_size: 100,
      version: "2.4",
      type: "house_status",
      house_id: this.id,
    };
    this.calendarService.getHouseListV2(params).subscribe((res) => {
      // this.houseInfo = _.get(res, 'data.list[0]');
      // this.houseInfo = this.houseCalendarService.generateStatusParentEntity(res?.data?.list?.[0]);

      this.houseInfo = this.updateRelatedHouseInfo(res?.data?.house_type_map, res?.data?.list);

      // this.changeUniqueKey(_.get(_.head(keyList), 'unique_key'));
      console.log("houseinfo: ", this.houseInfo);
    });
  }

  private fetchCalendarV2() {
    const begin = moment(head(this.listOfMonthOption), "YYYY-MM").startOf("month").format("YYYY-MM-DD");
    const end = moment(last(this.listOfMonthOption), "YYYY-MM").endOf("month").format("YYYY-MM-DD");
    const house_ids = [this.id];
    const params = {
      house_ids,
      begin,
      end,
      format: "only_lead_price",
    };
    this.http.get(this.CalendarApi, { params }).subscribe((rst: any) => {
      const calendar = rst?.data?.list?.[0]?.calendar;
      const resvs = rst?.data?.reservations;
      const hourResvs = rst?.data?.hour_reservations;
      const tasks = rst?.data?.schedule_tasks;

      this.calendarMap = this.generateResvAndPriceInfo(keyBy(calendar, "date"), resvs);
      this.hourReservationMap = this.generateHourResvMap(hourResvs);
      this.taskMap = this.generaateTaskMap(tasks);
    });
  }

  private generateResvAndPriceInfo(calendarMap, resvMap: any[]) {
    return mapValues(calendarMap, (calendar) => {
      // 生成价格和 rules 信息
      calendar.prices = calendar.prices.map((price) => {
        const { setting } = price;
        return {
          ...price,
          setting: setting
            ? {
                ...setting,
                showMoon: setting.min_stay_on_arrival || setting.min_stay_through,
                // ||
                // setting.max_stay_on_arrival ||
                // setting.max_stay_through ||
                // setting.exact_stay_on_arrival,
                moonCount: Math.max(setting.min_stay_on_arrival || 0, setting.min_stay_through || 0),
                showFlag: setting.min_advance_res || setting.max_advance_res || setting.seasonal_rule,
                showLock: setting.closed_on_arrival || setting.closed_on_departure,
              }
            : null,
        };
      });
      // 生成订单信息
      const code = calendar.reservation;
      const resv = find(resvMap, { code });
      if (resv) {
        const { check_in, check_out, out_status } = resv;

        return {
          ...calendar,
          resv: resv,
          resvHead: calendar.date === check_in,
          resvLast: isSameDay(
            subDays(parse(check_out, "yyyy-MM-dd", new Date()), 1),
            parse(calendar.date, "yyyy-MM-dd", new Date()),
          ),
          resvNights: differenceInDays(new Date(check_out), new Date(check_in)),
          resvBefore: out_status === "wait_stay",
          resvChecking: out_status === "staying",
          resvAfter: out_status === "completed",
        };
      }
      return calendar;
    });
  }

  private generateHourResvMap(resvs: any[]) {
    return groupBy(resvs, "check_in");
  }

  private generaateTaskMap(tasks: any[]) {
    return groupBy(tasks, "expected_date");
  }

  async fetchCommonConfig() {
    const res = await this.commonConfigService.getSettings().toPromise();
    const channels = _.get(res, "data.reservation_channel") || [];
    const reservationStyle = _.get(res, "data.house_status_setting.reservation_style") || 0;

    this.updateReservationStyle(reservationStyle);
    this.updateChannelColorMap(channels);
  }

  private updateRelatedHouseInfo(typeList, houseList) {
    const houseMap = _.keyBy(houseList, "id");
    const parent: Parent = this.calendarSrv.generateStatusParentEntity(typeList?.[0]);
    const child: Child = this.calendarSrv.generateStatusChildEntity(houseMap[this.id], parent);
    parent.p_children = [child];
    return child;
  }

  private updateChannelColorMap(list: Array<any>) {
    this.channelColorMap = _.keyBy(list, "code");
    console.log("[this.channelColorMap]: ", this.channelColorMap);
  }

  private updateReservationStyle(style) {
    this.reservationStyle = style === 0 ? "status" : "channel";
  }

  /**
   * 4.4.0 改成过去 12 个月和未来 24 个月
   */
  private initMonthOptions() {
    // const month = moment().month();

    const s = performance.now();

    const result = [];

    const start = moment().subtract(12, "month").date(1);
    const end = moment().add(2, "year").date(1);
    // const start = moment().subtract(2, "month").date(1);
    // const end = moment().add(2, "month").date(1);

    while (start.isSameOrBefore(end, "month")) {
      result.push(start.format("YYYY-MM"));
      // result.push(this.dateService.format(start, ['YM']));
      start.add(1, "month");
    }
    this.listOfMonthOption = result;

    const e = performance.now();
  }

  private scrollTo(month: string) {
    // const ancesotrContainer = this.calendarContainer.nativeElement.closest('.ant-drawer-body');
    // console.log('ancestor: ', ancesotrContainer);

    const index = this.listOfMonthOption.indexOf(month);

    console.log("scroll to: ", month, " index: ", index);

    if (index !== -1) {
      // const container = this.calendarContainer.nativeElement;
      const container = this.scrollContainerV2.nativeElement;
      const clientOffsetTop = container.offsetTop;

      const items = container.querySelectorAll(".calendar-item");

      const indexedDom = items[index];
      indexedDom?.scrollIntoView();

      // const PaddingTop = 0;
      // container.scrollTop = indexedDom.offsetTop - PaddingTop;
      // console.log('scrollTop: ', container.scrollTop, ' offsetTop: ', indexedDom.offsetTop);
      // const layout = document.querySelector('.ant-layout-content');
      // ancesotrContainer.scrollTop = clientOffsetTop + indexedDom.offsetTop - 74;
      // this.scrollable.scrollTo({
      //   top: clientOffsetTop + indexedDom.offsetTop
      // })
    }
  }

  private findInviewdItems(
    container: {
      top: number;
      height: number;
    },
    item: HTMLElement,
  ) {
    const itemRect = item.getBoundingClientRect();
    const { top, height } = itemRect;

    const month = item.dataset.month;

    if (top + height >= container.top && top <= container.top + container.height) {
      console.log(month + " in view");
      this.inviewedMonth.add(month);
    } else {
      this.inviewedMonth.delete(month);
    }

    // if (itemTop + 238 + )

    console.log(month + " itemtop: ", itemRect, " scrollTop: ", container);
  }

  subscribeScrollEvent() {
    const container = this.scrollContainerV2.nativeElement;
    fromEvent(container, "scroll")
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((event) => {
        const containerRect = container.getBoundingClientRect();
        // 获取所有需要监测的元素
        const elements: HTMLElement[] = Array.from(container.querySelectorAll(".calendar-skeleton"));

        // 开始监测每个元素
        elements.forEach((element) => {
          this.findInviewdItems(
            {
              top: containerRect.top,
              height: containerRect.height,
            },
            element,
          );
        });

        /**
         * @todo
         * @compact
         */
        this.cdr.markForCheck();
      });

    // return;
    // this.scrollDispatcher.scrolled(300).subscribe((rst: CdkScrollable) => {
    //   const containerRect = rst.getElementRef().nativeElement.getBoundingClientRect();
    //   // 获取所有需要监测的元素
    //   const elements: HTMLElement[] = Array.from(
    //     this.calendarContainer.nativeElement.querySelectorAll(".calendar-skeleton"),
    //   );

    //   console.log("elementes: ", elements);
    //   // 开始监测每个元素
    //   elements.forEach((element) => {
    //     this.findInviewdItems(
    //       {
    //         top: containerRect.top,
    //         height: containerRect.height,
    //       },
    //       element,
    //     );
    //   });
    // });
  }

  onToggleView(name: "price" | "rule") {
    if (name === "price") {
      this.showLeadChannel = !this.showLeadChannel;
      this.setLocalCachedValue("price", this.showLeadChannel);
    } else {
      this.showBookingRulesOfLC = !this.showBookingRulesOfLC;
      this.setLocalCachedValue("rule", this.showBookingRulesOfLC);
    }
  }

  onSelectCell(data: SelectedData<"house", "status">) {
    this.selectedReservation = null;
    this.listOfSelectedDates = data.dates;
    this.selectStatus = data.status;
    if (data.status === "done") {
      console.log("on select cell done");
      console.log("start open");
      const s = performance.now();
      this.drawerHelper.open(DrawerType.HostexSidebar, {
        selectedData: data,
      });
      const e = performance.now();
      console.log("end open: ", e - s);
    } else {
      this.drawerHelper.close("all");
    }
  }

  onSelectResv(code) {
    this.listOfSelectedDates = {
      head: null,
      last: null,
    };
    this.selectedReservation = code;
    if (code) {
      this.drawerHelper.open(DrawerType.ResvDetail);

      // this.houseCalendarService.cancelSelect();

      // this.offsetDrawerRef(370);
      // this.resvDetailDrawerRef = this.modal.displayResvDetailDrawer(value, this.resvDetailDrawerRef);
      console.log("resvDetailDrawerRef: ", this.resvDetailDrawerRef);
    } else {
      this.drawerHelper.close(DrawerType.ResvDetail);
      // this.offsetDrawerRef(0);
      // this.resvDetailDrawerRef?.close();
      console.log("resvDetailDrawerRef: ", this.resvDetailDrawerRef);
    }
  }

  onCreateHourResv(params) {
    this.drawerHelper.open(DrawerType.HourResvSidebar, { data: params });
  }

  onMonthChange(month: string) {
    this.scrollTo(month);
  }

  @WritePermissionGurd("calendar")
  onClickChangeAvailable(data) {
    console.log("data: ", data);
    this.calendarSrv.requestUpdateAvailable(data.status);
    // this.requestChangeHouseAvailable(data);
  }

  @WritePermissionGurd("calendar")
  onClickChangeTab(name) {
    this.calendarSrv.changeTab(name);
  }

  onClickTask(task) {
    console.log("on click task: ", task);
    // this.taskDrawerRef?.close();

    const title = this.t.t(`task.word.type.type_${task.type}`) + this.dateSrv.format(task.expected_date, ["MD"]);
    const params = {
      taskId: task.id,
      houseId: task.house_id,
      date: task.expected_date,
    };
    // const ref = this.modal.displayTaskDetailDrawer(title, params);

    this.drawerHelper.open(DrawerType.TaskDetail, title, params);

    this.taskDrawerRef.afterClose.subscribe(() => {
      this.fetchCalendarV2();
    });

    // this.taskDrawerRef = ref;
  }

  onClickCreateTask(date: string) {
    const modal = this.modal.displayCreateTaskModal({
      expected_date: date,
      house_id: this.id,
    });

    modal.afterClose.subscribe(() => {
      this.fetchCalendarV2();
    });
  }

  onClickEditNote(data) {
    const params = {
      house_id: this.id,
      ...data,
    };

    let request$;
    if (!params.note && params.note !== 0) {
      request$ = this.calendarService.deleteNote(params);
    } else {
      request$ = this.calendarService.addNote(params);
    }
    request$.subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.fetchCalendarV2();
      }
    });
  }

  onClickExtendStay(code) {
    const modal = this.nzModal.create({
      nzTitle: this.t.t("order.continue_stay"),
      nzContent: ContinueStayComponent,
      nzFooter: null,
      nzWidth: 390,
      nzData: {
        reservation_code: code,
        type: "single",
      },
    });
    modal.afterClose.subscribe((res) => {
      this.fetchCalendarV2();
    });
  }

  changeDate(type: "month" | "year", date?: string) {
    this.scrollTo(date);
    return;

    const current = { type, date };
    if (!date) {
      _.assign(current, {
        date: type === "month" ? moment().format("YYYY-MM") : moment().format("YYYY"),
      });
    }
    this.dateChangeRaw$.next(current);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();

    this.drawerHelper.close("all");
    // this.hostexSiderbarDrawerRef?.close();
    // this.hourResvSidebarDrawerRef?.close();
  }
}
